/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Stable Dependency workflow semantics independent of Jira labels.
 */
export enum RoadmapDependencyStatusBucket {
    BACKLOG = 'backlog',
    NEEDS_INFO = 'needs_info',
    REVIEW_READY = 'review_ready',
    ESCALATED = 'escalated',
    DECLINED = 'declined',
    DEPRIORITIZED = 'deprioritized',
    FUNDED = 'funded',
    IN_PROGRESS = 'in_progress',
    COMPLETED = 'completed',
    OTHER = 'other',
}
